import React, { useEffect, useRef } from 'react';
import { FaBolt, FaGlobe, FaTrophy, FaCheck } from 'react-icons/fa';

const Hero = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let particles = [];
    let w, h;

    const resizeCanvas = () => {
      const rect = canvas.parentElement.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
      w = canvas.width;
      h = canvas.height;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    class Particle {
      constructor() {
        this.x = Math.random() * w;
        this.y = Math.random() * h;
        this.size = Math.random() * 2 + 0.5;
        this.speedX = (Math.random() - 0.5) * 0.3;
        this.speedY = (Math.random() - 0.5) * 0.3;
        this.opacity = Math.random() * 0.4 + 0.1;
      }
      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        if (this.x < 0 || this.x > w) this.speedX *= -1;
        if (this.y < 0 || this.y > h) this.speedY *= -1;
      }
      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(201, 162, 39, ${this.opacity})`;
        ctx.fill();
      }
    }

    for (let i = 0; i < 80; i++) {
      particles.push(new Particle());
    }

    const animate = () => {
      ctx.clearRect(0, 0, w, h);
      particles.forEach(p => {
        p.update();
        p.draw();
      });
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.strokeStyle = `rgba(201, 162, 39, ${0.04 * (1 - dist / 120)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <section className="hero" id="hero">
      <div className="hero-bg"></div>
      <div className="hero-shapes">
        <div className="shape"></div>
        <div className="shape"></div>
        <div className="shape"></div>
      </div>
      <canvas ref={canvasRef} id="particles-canvas"></canvas>

      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="dot"></span>
              Global Wholesale Supplier
            </div>
            <h1>
              Your Trusted Source for<br />
              <span className="highlight">Genuine American</span> Auto Parts
            </h1>
            <p className="hero-sub">
              Wholesale Supplier of Genuine MOPAR, Motorcraft, GM &amp; ACDelco Parts
            </p>
            <div className="hero-tagline">
              <span>Genuine Parts</span>
              <span>Competitive Pricing</span>
              <span>Reliable Global Supply</span>
            </div>
            <div className="hero-buttons">
              <a href="#contact" className="btn-primary">
                <span className="btn-content">
                  Request Wholesale Quote
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </span>
              </a>
              <a href="#about" className="btn-secondary">
                <span className="btn-content">Learn More</span>
              </a>
            </div>
          </div>

          <div className="hero-visual">
            <div className="floating-card">
              <FaBolt className="card-icon" />
              <div className="card-label">Genuine Parts</div>
              <div className="card-value">100%</div>
              <div className="card-sub">OEM Quality</div>
            </div>
            <div className="floating-card">
              <FaGlobe className="card-icon" />
              <div className="card-label">Global Export</div>
              <div className="card-value">40+</div>
              <div className="card-sub">Countries</div>
            </div>
            <div className="floating-card">
              <FaTrophy className="card-icon" />
              <div className="card-label">Trusted Since</div>
              <div className="card-value"><span className="gold">2010</span></div>
              <div className="card-sub">Dubai, UAE</div>
            </div>
          </div>
        </div>
      </div>


      <div className="scroll-indicator">
        <div className="mouse"></div>
        <span>Scroll</span>
        <div className="line"></div>
      </div>
    </section>
  );
};

export default Hero;